import { render, staticRenderFns } from "./selectorTable.vue?vue&type=template&id=38f3d2a7"
import script from "./selectorTable.vue?vue&type=script&lang=js"
export * from "./selectorTable.vue?vue&type=script&lang=js"
import style0 from "./selectorTable.vue?vue&type=style&index=0&id=38f3d2a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports